import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
  <div><h6 class="mb-0">Amnex ITMS Product</h6></div>
    <div class="created-by ml-auto">
      <a href="#" (click)="$event.preventDefault()" target="_blank"><img src="assets/images/product/Powered by AMNEX.svg" class="" alt="amnex logo" /> </a>
    </div>
    
  `,
})
export class FooterComponent {
}
